'use strict';

import 'angular';

import timeElapsedDirective from './elapsed';

const MODULE_NAME = 'brg.components.time';

var app = angular.module(MODULE_NAME, [
]);
app.directive('timeElapsed', timeElapsedDirective);

export default MODULE_NAME;
